import { rem, radius, spacing, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const borderBlockStyles = css`
  :host {
    align-items: center;
    background-color: ${token('status-info-background')};
    border: ${rem(1)} solid;
    border-color: ${token('border-block-border-default')};
    border-radius: ${radius('small')};
    color: ${token('border-block-foreground-default')};
    display: flex;
    gap: ${spacing(100)};
    justify-content: space-between;
    padding: 0;
  }

  :host([type='success']) {
    background: ${token('status-success-background')};
    border-color: ${token('border-block-success-border-default')};
  }

  :host([type='error']) {
    background: ${token('status-danger-background-hover')};
    border-color: ${token('border-block-error-border-default')};
  }

  :host([type='tint']) {
    background: ${token('background-tertiary')};
    border-color: ${token('border-block-tint-border-default')};
  }

  :host([type='filter']) {
    background: ${token('status-progress-background')};
    border-color: ${token('status-progress-border')};
  }

  :host([size='small']) {
    font-size: ${rem(14)};
  }

  :host([size='small']) .main {
    padding: ${spacing(75, 100)};
  }

  :host([size='small']) button {
    padding: ${spacing(100)};
  }

  :host([size='tiny']) {
    font-size: ${rem(12)};
    font-weight: normal;
  }
  :host([size='tiny']) .main {
    padding: ${spacing(50, 75)};
  }
  :host([size='tiny']) button {
    padding: ${spacing(75)};
  }

  .main {
    padding: ${spacing(150, 200)};
  }

  .title {
    font-weight: bold;
  }

  button {
    align-self: flex-start;
    display: flex;
    font-size: ${rem(16)};
    padding: ${spacing(100)};
  }

  button:hover {
    color: ${token('text-link-default')};
  }

  :host([disabled]) {
    button {
      opacity: 0.2;
      pointer-events: none;
    }
  }
`;
